<div class="modal fade modal-full-width modal-full-height">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Criar lançamento na análise de mercado
                </h4>
                <!-- <h6 class="modal-subtitle">

                </h6> -->
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div *ngIf="entityCreate">
                        <div class="row">
                            <div class="form-group col-12">
                                <label class="col-form-label" for="entityCreateCliente">Cliente</label>
                                <ng-template [ngIf]="canEditCliente">
                                    <sgt-typeahead-cliente [(ngModel)]="entityCreate.cliente" name="entityCreateCliente" id="entityCreateCliente"
                                        #typeaeadCliente #entityCreateCliente="ngModel" [ngControl]="entityCreateCliente" required="required"
                                        (entitySelected)="onSelectCliente($event)" (clearEntity)="onClearCliente()">
                                    </sgt-typeahead-cliente>
                                    <sgt-form-control-error
                                        *ngIf="entityCreateCliente.errors && entityCreateCliente.errors.required && entityCreateCliente.dirty"
                                        msgError="O cliente é obrigatório">
                                    </sgt-form-control-error>
                                </ng-template>

                                <ng-template [ngIf]="!canEditCliente">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                          <span class="input-group-text">{{entityCreate?.cliente?.pessoa?.codigoIntegracaoErp}}</span>
                                        </div>
                                        <input type="text" class="form-control" [value]="entityCreate?.cliente?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                    </div>
                                    <p class="form-text text-muted" *ngIf="entityCreate?.cliente">
                                        {{entityCreate?.cliente?.pessoa?.nomeFantasia}} - {{entityCreate?.cliente?.pessoa?.cnpjCpf}} - {{entityCreate?.cliente?.pessoa?.enderecoPrincipal?.cidade?.nome}} - {{entityCreate?.cliente?.pessoa?.enderecoPrincipal?.cidade?.estado?.uf}}
                                    </p>
                                </ng-template>
                            </div>
                        </div>

                        <!-- <div class="row" *ngIf="!isRepresentante">
                            <div class="form-group form-group-representante col-12">
                                <label class="col-form-label">Representante</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">{{entityCreate?.representante?.pessoa?.codigoIntegracaoErp}}</span>
                                    </div>
                                    <input type="text" class="form-control" [value]="entityCreate?.representante?.pessoa?.nome" disabled="disabled" readonly="readonly">
                                </div>
                                <p class="form-text text-muted" *ngIf="entityCreate?.representante">
                                    {{entityCreate?.representante?.pessoa?.nomeFantasia}} - {{entityCreate?.representante?.pessoa?.cnpjCpf}}
                                </p>
                            </div>
                        </div> -->

                        <!-- <div class="row">
                            <div class="form-group col-12 col-lg-3">
                                <label class="col-form-label" for="entityCreateAno">Ano</label>
                                <ng-template [ngIf]="canEditAno">
                                    <sgt-datepicker [(ngModel)]="entityCreate.data" name="entityCreateAno" id="entityCreateAno"
                                        #entityCreateAno="ngModel" #anoDatepicker [ngControl]="entityCreateAno" [required]="true"
                                        [mode]="datePickerMode"
                                        [periodicidade]="datePickerPeriodicidade"
                                        [showBtnCalendar]="false"
                                        [withNavigation]="true"
                                        [(ano)]="entityCreate.ano">
                                    </sgt-datepicker>
                                    <sgt-form-control-error
                                        *ngIf="entityCreateAno.errors && entityCreateAno.errors.required && entityCreateAno.dirty"
                                        msgError="O ano é obrigatório">
                                    </sgt-form-control-error>
                                </ng-template>
                                <ng-template [ngIf]="!canEditAno">
                                    <input type="text" class="form-control" [value]="entityCreate.ano" disabled="disabled" readonly="readonly">
                                </ng-template>
                            </div>
                        </div> -->

                        <!-- <div class="row">
                            <div class="form-group col-12">
                                <label class="col-form-label">Periodicidade</label>
                                <div class="custom-control custom-radio">
                                    <input type="radio" class="custom-control-input" name="entityCreatePeriodicidade" id="entityCreatePeriodicidade_anual"
                                        #entityCreatePeriodicidadeInput="ngModel" [value]="lancamentoPeriodicidadeAnual.id" [(ngModel)]="entityCreate.periodicidade">
                                    <label class="custom-control-label" for="entityCreatePeriodicidade_anual">{{lancamentoPeriodicidadeAnual.nome}}</label>
                                </div>
                                <div class="custom-control custom-radio">
                                    <input type="radio" class="custom-control-input" name="entityCreatePeriodicidade" id="entityCreatePeriodicidade_mediaMensal"
                                        #entityCreatePeriodicidadeInput="ngModel" [value]="lancamentoPeriodicidadeMediaMensal.id" [(ngModel)]="entityCreate.periodicidade">
                                    <label class="custom-control-label" for="entityCreatePeriodicidade_mediaMensal">{{lancamentoPeriodicidadeMediaMensal.nome}}</label>
                                </div>
                                <div class="custom-control custom-radio">
                                    <input type="radio" class="custom-control-input" name="entityCreatePeriodicidade" id="entityCreatePeriodicidade_mensal"
                                        #entityCreatePeriodicidadeInput="ngModel" [value]="lancamentoPeriodicidadeMensal.id" [(ngModel)]="entityCreate.periodicidade">
                                    <label class="custom-control-label" for="entityCreatePeriodicidade_mensal">{{lancamentoPeriodicidadeMensal.nome}}</label>
                                </div>
                            </div>
                        </div> -->

                        <!-- Classificações Itens -->
                        <ng-template [ngIf]="config?.isPerspectivaClassificacao">
                            <sgt-cliente-analise-mercado-lancamento-classificacao-create
                                #classificacaoCreate
                                [(idGrupoClassificacao)]="entityCreate.idGrupoClassificacao"
                                [(entitiesCreate)]="entityCreate.classificacoes">
                            </sgt-cliente-analise-mercado-lancamento-classificacao-create>
                        </ng-template>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="cancel()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-success" id="btnClienteAnaliseMercadoLancamentoCreateModal" [disabled]="!form.valid" (click)="create()">
                    Criar Lançamento
                </button>
            </div>
        </div>
    </div>
</div>
